import axios from 'axios';
// axios.<method> will now provide autocomplete and parameter typings
const token = localStorage.getItem('token');
const Axios = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_API,
	timeout: 3000,
	headers: { Authorization: 'Bearer ' + token }
});

Axios.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		if (error.response?.status === 401) {
			window.location.href = '/login';
		}
		if (error.response?.status === 400 || error.response?.status === 422) {
			//place your reentry code

			try {
				alert(error.response.data.detail.message);
			} catch (err) {
				alert(error.response.data);
			}
		}

		return error;
	}
);

export default Axios;
